import { Editor, Element, Range } from 'slate';
import { getClosestWordRange } from './getClosestWordRange.mjs';
import { someNode } from '../../core/queries/someNode.mjs';
import { isVoidNode } from '../../core/queries/isVoidNode.mjs';

function getText(editor, {
  at,
  expandToClosestWord
}) {
  if (!at) {
    return null;
  }
  const element = Editor.fragment(editor, at)[0];
  const children = Element.isElement(element) ? element.children : [];
  const selectionWithinSingleBlock = children.length === 1;
  const selectionContainsVoidNode = someNode(editor, {
    at,
    match: node => isVoidNode(editor, node)
  });
  if (!selectionWithinSingleBlock || selectionContainsVoidNode) {
    return null;
  }
  return Editor.string(editor, expandToClosestWord && Range.isCollapsed(at) ? getClosestWordRange(editor, at) : at);
}

export { getText };
